import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { closeAlert } from '@actions/alert'
import s from './AlertNotification.css'
import types from '../../constants'

class AlertNotification extends Component {
  constructor(props) {
    super(props)
    this.state = {
      timeout: props.timeout || 8, // in seconds
    }
  }

  componentDidMount() {
    // this.handleTimeout()
  }

  componentDidUpdate(prevProps) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.props.alertNotification.isShow) {
      this.handleTimeout()
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  handleTimeout = () => {
    this.timeout = setTimeout(() => {
      this.props.closeAlert()
    }, this.state.timeout * 1000)
  }

  handleOnClose = () => {
    this.props.closeAlert()
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.props.handleOnClose) {
      this.props.handleOnClose()
    }
  }

  renderAlert = () => {
    const { text, isSuccess, isMobile, alertNotification } = this.props

    return (
      <div className={s.an__container} onClick={() => isMobile && this.handleOnClose()}>
        <div className={`${alertNotification.alertType === types.SUCCESS ? s.an__wrapper_green : s.an__wrapper_red}`}>
          <div className={s.an__content_text}>{alertNotification.alertMessage}</div>
          {!isMobile ? <div className={`${s.an__content_img}`} onClick={this.handleOnClose}></div> : ''}
        </div>
      </div>
    )
  }

  renderNewAlertDesign = () => {
    const { text, isSuccess, isMobile, alertNotification, withSideNavLayout } = this.props

    if (isMobile && alertNotification.isShow) {
      return this.renderAlert() // temporary
    }

    return (
      <div
        style={{ left: withSideNavLayout ? '5.7rem' : '0' }}
        className={`${s.an__container_wrap} ${
          alertNotification.isShow ? s.an__alert_show : !isMobile && s.an__alert_hide
        }`}
      >
        <div className={s.an__alert_content}>
          <div style={{ display: 'flex' }}>
            <div
              className={`${s.an__new_content_img} ${
                alertNotification.alertType === types.SUCCESS ? s.an__icon_success : s.an__icon_error
              }`}
            ></div>
            <div className={s.an__alert_content_left}>{alertNotification.alertMessage}</div>
          </div>
          <div onClick={this.handleOnClose} className={s.an__alert_content_right}>
            Close
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { alertNotification, isMobile } = this.props
    return this.renderNewAlertDesign()
  }
}

const mapStateToProps = state => {
  return {
    alertNotification: state.alertNotification,
  }
}

const mapDispatchToProps = dispatch => ({
  closeAlert: () => dispatch(closeAlert()),
})

export default compose(withStyles(s), connect(mapStateToProps, mapDispatchToProps))(AlertNotification)
